<div class="regras-natureza">

  <app-regras-toolbar
    [busca]="busca"
    [filtroAtivo]="filtroAtivo"
    [situacaoOptions]="filtroSituacaoOptions"
    [carregando]="loading"
    placeholder="Código da natureza"
    rotuloNovo="Nova natureza"
    (buscar)="filtrar($event)"
    (filtrarSituacao)="onFiltroSituacao($event)"
    (atualizar)="carregar()"
    (novo)="abrirNova()">
  </app-regras-toolbar>

  <app-regras-skeleton
    *ngIf="loading && !itens.length"
    rotulo="Carregando as naturezas por perfil de retenção">
  </app-regras-skeleton>

  <po-table
    *ngIf="!loading || itens.length"
    [p-columns]="columns"
    [p-items]="itens"
    [p-actions]="tableActions"
    [p-loading]="loading || loadingMore"
    [p-sort]="true"
    [p-striped]="true"
    [p-height]="tableHeight"
    [p-show-more-disabled]="!hasMore"
    (p-show-more)="carregarMais()">
  </po-table>

</div>

<po-modal
  #formModal
  [p-title]="modalTitle"
  p-size="lg"
  [p-primary-action]="modalPrimaryAction"
  [p-secondary-action]="modalSecondaryAction">

  <div class="regras-form" [formGroup]="formGroup">

    <div class="po-row" *ngIf="duplicando">
      <small class="po-md-12 po-font-text-small">
        Cópia da natureza <b>{{ editing?.codigo }}</b>, com a ordem de avaliação
        limpa.
      </small>
    </div>

    <div class="po-row">
      <small class="po-md-12 po-font-text-small">
        O perfil é comparado por <b>percentual de retenção</b> sobre o valor do
        serviço, com a tolerância informada — não pelo valor retido.
      </small>
    </div>

    <div class="po-row">
      <po-select
        class="po-md-6"
        p-label="Filial da regra"
        p-help="Em branco, vale para todas as filiais"
        [p-options]="filiaisOptions"
        formControlName="filial">
      </po-select>

      <po-select
        class="po-md-6"
        p-label="IRRF"
        [p-options]="irrfOptions"
        formControlName="irrf"
        p-required>
      </po-select>
    </div>

    <div class="po-row">
      <po-select
        class="po-md-4"
        p-label="PIS/COFINS/CSLL retidos"
        [p-options]="simNaoOptions"
        formControlName="pcc"
        p-required>
      </po-select>

      <po-select
        class="po-md-4"
        p-label="INSS retido"
        [p-options]="simNaoOptions"
        formControlName="inss"
        p-required>
      </po-select>

      <po-select
        class="po-md-4"
        p-label="ISS retido"
        [p-options]="simNaoOptions"
        formControlName="iss"
        p-required>
      </po-select>
    </div>

    <div class="po-row">
      <po-combo
        class="po-md-6"
        p-label="Natureza financeira resultante"
        p-filter-service="portalnf/regras/lookup/natureza"
        p-field-label="label"
        p-field-value="value"
        [p-sort]="true"
        name="natureza"
        formControlName="natureza"
        [p-required]="true"
        [p-infinite-scroll]="true">
      </po-combo>

      <po-decimal
        class="po-md-3"
        p-label="Tolerância (p.p.)"
        p-help="Padrão 0,10 ponto percentual"
        [p-decimals-length]="2"
        formControlName="tolerancia">
      </po-decimal>

      <po-number
        class="po-md-3"
        p-label="Ordem de avaliação"
        formControlName="ordem"
        [p-min]="1"
        [p-max]="999"
        p-required>
      </po-number>
    </div>

    <div class="po-row">
      <po-datepicker
        class="po-md-4"
        p-label="Início da vigência"
        formControlName="dtIni">
      </po-datepicker>

      <po-datepicker
        class="po-md-4"
        p-label="Fim da vigência"
        p-help="Em branco = vigência em aberto"
        formControlName="dtFim">
      </po-datepicker>

      <po-select
        class="po-md-4"
        p-label="Situação"
        [p-options]="situacaoOptions"
        formControlName="ativo"
        p-required>
      </po-select>
    </div>

    <div class="po-row" *ngIf="editing?.usrAlt">
      <small class="po-md-12 po-font-text-small regras-auditoria">
        Última alteração por <b>{{ editing?.usrAltNome || editing?.usrAlt }}</b>
        em {{ formatarData(editing?.dtAlt) }} às {{ editing?.hrAlt }}.
      </small>
    </div>

  </div>

</po-modal>
